// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".musician-content {\n  width: 100%; }\n\n.info-container-mus {\n  width: calc(100% - 25px);\n  box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4);\n  border-radius: 15px;\n  margin-top: 10px; }\n\n.info-c {\n  width: 100%; }\n", ""]);
// Exports
module.exports = exports;
